export default "__VITE_ASSET__Cv$15AqU__"